import React, { Component } from 'react';
import { Form, Input, Button, Radio, Tooltip } from 'antd';
import InformationIcon from "../../assets/icons/information_icon.svg";
import { sendNotification, getNewPermission } from '../../utils/index'
import { injectIntl } from 'react-intl'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import { createFolder } from '../../actions/ClientAction'

const { TextArea } = Input;

class CreateFolderBody extends Component {
    constructor(props) {
      super(props);
      this.state = {
        name: '',
        bunker: props.bunkerEnabled,
        enabledTags: false,
        description: '',
        tagProtocol: '',
      };
    }
    handleChangeOption = e => {
      this.setState({
        bunker: e.target.value,
      });
    };
    handleChangeOptionTags = e => {
      this.setState({
        enabledTags: e.target.value,
      });
    };
    handleBunkerOnChange = e => {
      this.setState({
        bunker: e.target.value,
      });
    };
    handleOnChangeName = e => {
      this.setState({
        name: e.target.value,
      });
    };
    handleOnChangeDescription = e => {
      this.setState({
        description: e.target.value,
      });
    };
    handleOnChangeTagProtocol = e => {
      this.setState({
        tagProtocol: e.target.value,
      });
    };
    handleCreateFolder = (e) => {
      const {
        name,
        bunker,
        description,
        tagProtocol,
      } = this.state
      const { workclient, root, folderselect, user, intl, newMatrix } = this.props
      const isOperator = user.role !== 'admin' && user.clientRole !== 'admin'
      e.preventDefault();

      //Debe tener un nombre
      if(name.length === 0){
        sendNotification('error', intl, intl.formatMessage({ id: 'must_enter_valid_folder_name' }));
        return;
      }

      //Una carpeta se debe seleccionar un bunkey o carpeta
      if(!folderselect && !bunker){
        sendNotification('error', intl, intl.formatMessage({ id: 'must_select_folder' }));
        return;
      }

      //Un operador no puede crear un bunker
      if(isOperator && bunker){
        sendNotification('warning', intl, intl.formatMessage({ id: 'permission_denied' }));
        return;
      }

      //Una carpeta debe tener un protocolo de tags
      // if(!bunker && tagProtocol.length === 0){
      //   sendNotification('error', intl, intl.formatMessage({ id: 'invalid_tag_protocol' }));
      //   return;
      // }

      //Un operador debe tener el permiso de crear carpeta
      if(isOperator && !getNewPermission(folderselect, newMatrix, 'createFolder')){
        sendNotification('warning', intl, intl.formatMessage({ id: 'permission_denied' }));
        return;
      }

      //Un bunker debe tener una descripción
      if(bunker && description.length === 0){
        sendNotification('error', intl, intl.formatMessage({ id: 'invalid_bunker_description' }));
        return;
      }

      if(bunker){
        this.props.createFolder(workclient, root, name, root, folderselect, description, '', this.props.handleHiddenCreateFolderModal)
        return;
      }
      
      this.props.createFolder(workclient, folderselect, name, root, folderselect, '', tagProtocol, this.props.handleHiddenCreateFolderModal);

    }
    render() {
      const {
        name,
        bunker,
        enabledTags,
        description,
        tagProtocol
      } = this.state;

      const {
        isInFolderAction,
        handleHiddenCreateFolderModal,
        bunkerEnabled,
        intl,
        newColor
      } = this.props;

      return (
        <div
            style = {{
                width: "100%",
                height: 400,
                paddingLeft: "5%",
                paddingRight: "5%",
                paddingTop: "1%",
                paddingBottom: "1%",
            }}
        >
            <Form>
                <Form.Item style={{ marginBottom: '5px' }}>
                  <React.Fragment>
                      <span>{bunker ? intl.formatMessage({id: "upload-folder-create-bunker-name"}) : intl.formatMessage({id: "upload-folder-create-folder-name"})}</span>
                      <br />
                      <Radio.Group onChange={this.handleChangeOption} defaultChecked={bunker} value={bunker} size="small">
                          {bunkerEnabled && <Radio value={true}>{intl.formatMessage({id: "upload-folder-create-bunker-label"})}</Radio>}
                          {!bunkerEnabled && <Radio value={false}>{intl.formatMessage({id: "upload-folder-create-folder-label"})}</Radio>}
                      </Radio.Group>
                  </React.Fragment>
                </Form.Item>
                <Form.Item style={{ marginBottom: '0' }}>
                  <span>{intl.formatMessage({id: "name"})}</span>
                  <Input
                    value={name}
                    onChange={this.handleOnChangeName}
                    maxLength={75}
                    placeholder={bunker ? intl.formatMessage({id: "create_bunker_name_specifies"}) : intl.formatMessage({id: "create_folder_name_specifies"})} 
                  />
                </Form.Item>
                {/* Tags */}
                {!bunker ? <Form.Item>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                      <span>{intl.formatMessage({id: "tags_protocol"})}</span>
                      <Tooltip
                        title={intl.formatMessage({id: "upload-folder-create-tag-m1"})}
                        color={newColor}
                        placement="left"
                      >
                        <img src={InformationIcon} alt = "Information" style = {{width: 18, height: 18}}/>
                      </Tooltip>
                  </div>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                      <span style={{ fontSize: 12, color: "#A3A3A3", lineHeight: "15px" }}>
                        {intl.formatMessage({id: "upload-folder-create-tag-act"})}
                      </span>
                      <Radio.Group onChange={this.handleChangeOptionTags} defaultChecked={enabledTags} value={enabledTags} size="small">
                        <Radio value={true}>{intl.formatMessage({id: "module_activate"})}</Radio>
                        <Radio value={false}>{intl.formatMessage({id: "module_deactivate"})}</Radio>
                      </Radio.Group>
                  </div>
                  {enabledTags && <TextArea
                    rows={3}
                    placeholder={intl.formatMessage({id: "new_folder_description"})}
                    name="tag_protocol"
                    maxLength={75}
                    value={tagProtocol}
                    onChange={this.handleOnChangeTagProtocol} 
                  />}
                </Form.Item> : <Form.Item>
                  <span>{intl.formatMessage({id: "editDescriptionDart_permission"})}</span>
                  <TextArea
                    rows={3}
                    placeholder={intl.formatMessage({id: "new_folder_description"})}
                    name="description"
                    maxLength={75}
                    value={description}
                    onChange={this.handleOnChangeDescription} 
                  />
                </Form.Item>}
                <div style={{ display: "flex", justifyContent: "space-evenly" }}>
                    <Button
                      type="primary"
                      style={{ backgroundColor: newColor, borderColor: newColor }}
                      onClick={this.handleCreateFolder}
                      loading={isInFolderAction}
                    >
                      {bunker ?  intl.formatMessage({ id: 'upload-folder-create-bunker' }) : intl.formatMessage({ id: 'upload-folder-create-folder' })}
                    </Button>
                    {/* Cancelar */}
                    <Button
                      type="default"
                      style={{ borderColor: newColor, color: newColor }}
                      onClick={handleHiddenCreateFolderModal}
                    >
                      {intl.formatMessage({id: "cancel_button"})}
                    </Button>
                </div>
            </Form>
        </div>
      );
	}
}
const mapStateToProps = state => {
  return {
    workclient: state.client.workclient,
    root: state.client.root,
    // folderselect: state.assetsExplore.folderselect ? state.assetsExplore.folderselect : state.uploadFolder.folderselect ? state.uploadFolder.folderselect : null,
    folderselect: state.uploadFolder.folderselect ? state.uploadFolder.folderselect : state.assetsExplore.folderselect ? state.assetsExplore.folderselect : null,
    user: state.authUser.user,
    newMatrix: state.group.newMatrix,
    isInFolderAction: state.client.isInFolderAction,
    newColor: state.authUser.user && state.authUser.user.color ? state.authUser.user.color : '#2E97CF',
  }
}

const mapDispatchToProps = {
  createFolder,
}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(CreateFolderBody)))
